export const TenderDocumentStatus = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted to Procurement',
  POSTED: 'Posted to Vendor',
  INACTIVE: 'Inactive',
}

export const CostBudgetType = {
  SUPPLY_MATERIAL_ONLY: 'SUPPLY_MATERIAL_ONLY',
  SUPPLY_SITE_WORK: 'SUPPLY_SITE_WORK',
  SUPPLY_SITE_WORK_RFQ: 'SUPPLY_SITE_WORK_RFQ',
  SUPPLY_ENGINEERING_SERVICE: 'SUPPLY_ENGINEERING_SERVICE',

  SUPPLY_MAINTENANCE_SERVICE: 'SUPPLY_MAINTENANCE_SERVICE',
  FRAME_AGREEMENT: 'FRAME_AGREEMENT',
}

export const CostBudgetTypeLabel = {
  SUPPLY_MATERIAL_ONLY: 'Supply Material Only',
  SUPPLY_SITE_WORK: 'Supply & Site Work',
  SUPPLY_SITE_WORK_RFQ: 'Supply & Site Work (RFQ)',
  SUPPLY_ENGINEERING_SERVICE: 'Supply Engineering Services',
  SUPPLY_MAINTENANCE_SERVICE: 'Supply Maintenance Service',
  FRAME_AGREEMENT: 'Frame Agreement',
}

export const OfferQuotationTemplateScopeOfWork = {
  INSTALLATION: 'Installation only',
  SUPPLY: 'Supply only',
  T_C: 'T&C',
  SUPPLY_INSTALLATION: 'Supply and Installation',
  SUPPLY_T_C: 'Supply and T&C',
  SUPPLY_INSTALLATION_T_C: 'Supply, Installation and T&C',
  ENGINEERING_WORKS: 'Engineering Works',
  MAINTENANCE: 'Maintenance',
  ENGINEERING_SERVICE: 'Engineering Service',
  A_A_WORK: 'A&A works',
  UPGRADE_WORKS: 'Upgrade works',
  MIGRATION_WORKS: 'Migration works',
  DEFECT_RETIFICATION_WORKS: 'Defect retification works',
  DEMOLITION_WORKS: 'Demolition works',
  CONFIGURATION_WORKS: 'Configuration Works',
  REPLACEMENT_WORKS: 'Replacement works',
  DEBRIS_REMOVAL: 'Debris Removal',
  OTHER_SITE: 'Other site works with detail description',
  DESIGN_ONLY: 'Design Only',
  DESIGN_AND_SUPPLY: 'Design and Supply',
  DESIGN_SUPPLY_INSTALLATION: 'Design, Supply and Installation',
  OPTIONAL_ITEMS: 'Optional items/ works',
}

export const SourcingPostType = {
  REQUEST_FOR_QUOTATION: 'requestForQuotation',
  REQUEST_FOR_TECHNICAL_SUPPORT_DOCUMENT: 'requestForTechnicalSupportDocument',
  REQUEST_FOR_UPDATE_OF_TERMS: 'requestForUpdateOfTerms',
  REQUEST_FOR_CLARIFICATION: 'requestForClarification',
  REQUEST_FOR_DETAILED_TABLE: 'requestForDetailedTable',
}

export const OfferQuotationDetailInstallAndSupplyUnit = {
  PCS: 'pcs',
  LOT: 'lot',
  NOS: 'nos',
  METER: 'meter',
  ROLLS: 'rolls',
  PANEL: 'panel',
  SET: 'set',
  MAN_DAY: 'Man day',
  POINT: 'point',
  YEAR: 'year',
  MONTH: 'month',
}
export const OfferQuotationDetailMaintenanceUnit = {
  MONTH: 'month',
  TIME: 'time',
  DEVICE: 'device',
  MAN_MONTH: 'man-month',
  MAN_DAY: 'man-day',
}

export const COST_BUDGET_SUPPLY_MATERIAL_ONLY_TABLE_COLUMNS = [
  'productDescription',
  'brand',
  'modelNumber',
  'category',
  'SAPMaterialNumber',
  'quantity',
  'unit',
  'unitRate',
  'discount',
  'totalPrice',
  'country',
  'AL',
  'ECCN',
  'HSCode',
  'ECCNDetail',
]

export const COST_BUDGET_SUPPLY_SITE_WORK_TABLE_COLUMNS = [
  'scopeOfWorkSelect',
  'productDescription',
  'brand',
  'modelNumber',
  'country',
  'AL',
  'ECCN',
  'HSCode',
  'category',
  'SAPMaterialNumber',
  'quantity',
  'unitSelect',
  'unitRate',
  'discount',
  'totalPrice',
]

export const COST_BUDGET_MAINTENANCE_TABLE_COLUMNS = [
  'siteLocation',
  'startDate',
  'endDate',
  'numberOfWorker',
  'system',
  'scopeOfWork',
  'description',
  'category',
  'SAPMaterialNumber',
  'quantity',
  'unitMaintenance',
  'unitRate',
  'discount',
  'totalPrice',
]

export const COST_BUDGET_SUPPLY_ENGINEERING_SERVICE_TABLE_COLUMNS = [
  'scopeOfWork',
  'productDescription',
  'numberOfWorker',
  'category',
  'SAPMaterialNumber',
  'quantity',
  'unitSelect',
  'unitRate',
  'discount',
  'totalPrice',
]

export const COST_BUDGET_HEADER_MAPPING = {
  //SUPPLY_MATERIAL_ONLY
  productDescription: 'Product Description',
  brand: 'Brand',
  modelNumber: 'Model Number',
  quantity: 'Quantity',
  unit: 'Unit',
  unitRate: 'Unit Rate',
  discount: 'Discount (%)',
  totalPrice: 'Total Price',
  country: 'Country',
  AL: 'AL',
  ECCN: 'ECCN',
  HSCode: 'HS Code',
  SAPMaterialNumber: 'SAP Material Number',
  ECCNDetail: 'ECCN Checklist',

  //SUPPLY_SITE_WORK
  scopeOfWorkSelect: 'Scope of Work',
  scopeOfWork: 'Scope of Work',
  unitSelect: 'Unit',
  unit: 'Unit',

  //MAINTENANCE
  siteLocation: 'Site Location',
  startDate: 'Start Date',
  endDate: 'End Date',
  numberOfWorker: 'Number of Worker',
  system: 'System',
  scopeOfWork: 'Scope of Work',
  description: 'Description',
  unitMaintenance: 'Unit',

  //SUPPLY_ENGINEERING_SERVICE
}
